import { getFromGql, logError } from 'actions';

import gql from 'graphql-tag';
import { ActionTypes as types } from 'constants';
import { updateFetchAppError } from 'actions/setters/updateAppErrors';

const QUERY = gql`
  query isStravaConnected {
    viewer {
      thirdPartyApplications {
        strava {
          isConnected
        }
      }
    }
  }
`;

const log = { component: 'getStravaStatus' };

export default (_getFromGql = getFromGql, _logError = logError) => (
  dispatch,
  getState,
) => {
  const { isLoaded } = getState().app.fitness;
  if (isLoaded) return Promise.resolve('isLoaded');

  dispatch({
    type: types.FETCH_STRAVA_STATUS,
  });

  return dispatch(_getFromGql(QUERY))
    .then(res => {
      if (!res) {
        throw new Error('No response');
      }
      if (res.errors && res.errors.length > 0) {
        throw new Error(res.errors[0].message);
      }

      if (res.data && res.data.viewer) {
        dispatch({
          type: types.FETCH_STRAVA_STATUS_SUCCESS,
          payload: res.data.viewer.thirdPartyApplications.strava,
        });
      }
    })
    .catch(error => {
      dispatch(updateFetchAppError());
      dispatch({ type: types.FETCH_STRAVA_STATUS_FAILURE });
      dispatch(
        _logError(types.UPDATE_APP_STATUS_FETCH_ERROR, { ...log, error }),
      );
    });
};
